import { api } from '../index';
import apiUrls from '../../../settings/api-urls';
import { interpolate } from '../../../utilities';

export const ruleSetsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getRuleSets: build.query({
            query: () => ({
                url: apiUrls.RULE_SETS,
                method: 'GET',
            }),
            transformResponse(res) {
                // sort results by createdAt descending
                return res.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            },
            providesTags: [ 'RULE_SETS' ],
        }),
        getRuleSetById: build.query({
            query: (id) => ({
                url: interpolate(apiUrls.RULE_SET, { ruleSetId: id }),
                method: 'GET',
            }),
            providesTags: [ 'RULE_SET' ],
        }),
        createRuleSet: build.mutation({
            query: (body) => ({
                url: apiUrls.RULE_SETS,
                method: 'POST',
                body,
            }),
            invalidatesTags: [ 'RULE_SETS' ],
        }),
        updateRuleSet: build.mutation({
            query: ({ id, body }) => ({
                url: interpolate(apiUrls.RULE_SET, { ruleSetId: id }),
                method: 'PATCH',
                body,
            }),
            invalidatesTags: [ 'RULE_SET', 'RULE_SETS' ],
        }),
        deleteRuleSet: build.mutation({
            query: (id) => ({
                url: interpolate(apiUrls.RULE_SET, { ruleSetId: id }),
                method: 'DELETE',
            }),
            invalidatesTags: [ 'RULE_SETS' ],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetRuleSetsQuery,
    useGetRuleSetByIdQuery,
    useCreateRuleSetMutation,
    useUpdateRuleSetMutation,
    useDeleteRuleSetMutation,
} = ruleSetsApi;
